import React, { useEffect }  from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import { connect } from "react-redux";
import { 
 getClientDetails, getClientUserDetails
} from "../../../../redux/client/clientState";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import ClientUserForm from "./components/ClientUserForm";


const ViewClientUser = ({
	clientDetails,
	getClientDetails,
  	getClientUserDetails,
	...props
 }) => { 

	const { recordId } = props;
	const { clientId, userId } = useParams();
    
	useEffect(() => {
		getClientDetails(clientId)
	}, [clientId, getClientDetails]);

	useEffect(() => {
		getClientUserDetails({clientId, userId});
	}, [userId, clientId, getClientUserDetails]);

	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<Card extra={"w-full h-full p-4"}>
					<div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
						<SectionHeader title={clientDetails?.clt_name || "Client"} />
					</div>
					<div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
						<SectionHeader title="Client User">
							<PopupButton id="edit_client_team" title="Edit Client User" label="Edit" >
								<ClientUserForm recordId={recordId} clientId={clientId} mode="edit"/>
							</PopupButton>
						</SectionHeader>
						<ClientUserForm recordId={userId} clientId={clientId} mode="view" />
					</div>
				</Card>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  clientDetails: state.client.clientDetails?.data,
  clientUserDetails: state.client.clientUserDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getClientDetails: (id) => dispatch(getClientDetails(id)),
	getClientUserDetails: (id) => dispatch(getClientUserDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewClientUser);